// extracted by mini-css-extract-plugin
module.exports = {"tagDelete":"tagDelete__QgdkM","tagAdd":"tagAdd__3kYrz","inputWrapper":"inputWrapper__1aWHr"};